import React, { createContext, ReactNode, useEffect, useState } from 'react';

export const ItemTypes = {
  CHARACTER: 'character',
}

export interface Item {
  // progressIndex: number,
  imgIndex: number,
  text: string,
  posAlias: string,
}

interface Props {
  children: ReactNode,
  // total: number,
  theText: string,
}

interface Context {
  theText: string,
  total: number,
  answers: Array<null | Item>,
  answersUpdated: number,
  setValue: (v: Context) => void,
  setAnswer: (index: number, answer: null | Item) => void,
}

const DEFAULTCONTEXT: Context = {
  theText: '',
  total: 0,
  answers: [],
  answersUpdated: Date.now(),
  setValue: (_v: Context) => { },
  setAnswer: (_index: number, _answer: null | Item) => { },
};

export const MovableTypePrintingContext = createContext<Context>(DEFAULTCONTEXT);

export default function MovableTypePrintingProvider(props: Props) {
  const [value, setValue] = useState<Context>(DEFAULTCONTEXT);

  useEffect(() => {
    console.log('MovableTypePrintingProvider', 'theText', 'useEffect');
    setValue(o => ({
      ...o,
      theText: props.theText,
      total: props.theText.length,
      answers: Array(props.theText.length).fill(null),
      setValue,
      setAnswer: (index: number, answer: null | Item) => {
        setValue(o => {
          let newAnswers = o.answers.slice(0);
          newAnswers.forEach((x, i) => { if (answer === x) { newAnswers[i] = null } })
          newAnswers[index] = answer;
          console.log(o.answers, newAnswers, Date.now());
          return {
            ...o,
            answers: newAnswers,
            answersUpdated: Date.now(),
          }
        })
      }
    }))
  }, [props.theText]);

  return (
    <MovableTypePrintingContext.Provider value={value}>
      {props.children}
    </MovableTypePrintingContext.Provider>
  )
}
